import React from "react";
import { Box, Typography, Button, Paper } from "@mui/material";
import { useHistory } from "react-router-dom";
import { getHomePage } from "modules/platform-components/utils/configuration";

const Forbidden403: React.FC = () => {
  const history = useHistory();

  const handleGoHome = () => {
    try {
      const home = getHomePage() || "/app/dashboard";
      history.push(home);
    } catch {
      history.push("/app/dashboard");
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "60vh",
        p: 3,
      }}
    >
      <Paper sx={{ p: 4, textAlign: "center", maxWidth: 480, borderRadius: 2 }}>
        <Typography
          variant="h2"
          sx={{ color: "#dc3545", fontWeight: "bold", mb: 1 }}
        >
          403
        </Typography>
        <Typography variant="h6" sx={{ mb: 1 }}>
          Access denied
        </Typography>
        <Typography variant="body2" sx={{ color: "#666", mb: 3 }}>
          You don't have permission to view this page. If you believe this is
          an error, please contact your administrator.
        </Typography>
        <Button
          variant="contained"
          onClick={handleGoHome}
          sx={{
            backgroundColor: "#3366FF",
            "&:hover": { backgroundColor: "#2952CC" },
            textTransform: "none",
          }}
        >
          Go to Home
        </Button>
      </Paper>
    </Box>
  );
};

export default Forbidden403;
